import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload) {
  const index = state.versetzungsplaene.findIndex(v => !!v.abteilungen?.find(a => a.id === payload.abteilungId))
  if (index >= 0) {
    state.versetzungsplaene[index].abteilungen = state.versetzungsplaene[index].abteilungen?.filter(
      a => a.id !== payload.abteilungId,
    )
  }
  return {
    ...state,
    isLoading: false,
  }
}
fulfilled.chain = (state, payload, result) => actions.versetzungsplan.readVersetzungsplan()

export function rejected(state) {
  return {
    ...state,
    isLoading: false,
  }
}

export async function action(payload) {
  try {
    return await Api.deleteAbteilung(payload.abteilungId)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
